<template>
  <div class="mode-icon">
    <Bike
      v-if="mode === 'BICYCLE'"
      :iconColor="color ? color : undefined"
      :width="width ? width : undefined"
    />
    <Bus
      v-else-if="mode === 'BUS'"
      :iconColor="color ? color : undefined"
      :width="width ? width : undefined"
    />
    <Rail
      v-else-if="mode === 'RAIL'"
      :iconColor="color ? color : undefined"
      :width="width ? width : undefined"
    />
    <Walk
      v-else
      :iconColor="color ? color : undefined"
      :width="width ? width : undefined"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import Bike from '@/components/Icons/Bike.vue';
import Bus from '@/components/Icons/Bus.vue';
import Rail from '@/components/Icons/Rail.vue';
import Walk from '@/components/Icons/Walk.vue';

export default {
  name: 'mode-icon',
  components: {
    Bike,
    Bus,
    Rail,
    Walk,
  },
  props: {
    mode: String,
    color: String,
    width: Number,
  },
};
</script>

<style lang="scss" scoped></style>
